import React, { useEffect, useState } from "react";

import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stusubjectlist,
} from "../../../services/master";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import { toast } from "react-toastify";
import { createhomework, homeworkview } from "../../../services/teacher";
import { studentfilter } from "../../../services/student";
import moment from "moment";

export default function Addhomework() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [stusec, setStuSec] = useState("");
  const [slist, setSList] = useState([]);

  // multi-subject: array of {value, label}
  const [subjects, setSubjects] = useState([]);
  const [sublist, setSubList] = useState([]);
  // per-subject descriptions: { [subject_id]: description }
  const [subjectDescs, setSubjectDescs] = useState({});

  const [adate, setADate] = useState("");

  const [hurl, setHUrl] = useState("");
  // per-subject file attachments
  const [subjectFiles, setSubjectFiles] = useState({});
  const [subjectFileUrls, setSubjectFileUrls] = useState({});
  const [subjectFileErrors, setSubjectFileErrors] = useState({});

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [urllink, setUrl] = useState("");
  const location = useLocation();

  const [stulist, setStuList] = useState([]);
  const [selectedStu, setSelectedStu] = useState("");

  // view-mode legacy fields
  const [subject, setSubject] = useState("");
  const [hwork, setHWork] = useState("");

  useEffect(() => {
    if (localStorage.getItem("ADate") !== '') {
      setADate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    } else {
      setADate(moment(new Date()).format("YYYY-MM-DD"));
    }
    const path = location.pathname.split("/")[2];
    setUrl(path);

    stuclasslist().then((res) => {
      if (res.status === true) {
        setCList(res.data.map((item) => ({ value: item.id, label: item.class_name })));
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        setSList(res.data.map((item) => ({ value: item.id, label: item.name })));
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        setACList(
          res.data.details.map((item) => ({
            value: item.id,
            label: item.name + " - " + item.code,
          }))
        );
      }
    });

    if (path === "homeworkdetail" || path === "viewhomework") {
      homeworkview(id).then((res) => {
        if (res.status === true && res.data.details !== null) {
          setAYear(res.data.details.academic_year);
          setStuCls(res.data.details.class_id);
          setStuSec(res.data.details.section);
          setSubject(res.data.details.subject);
          setADate(res.data.details.due_date);
          setHWork(res.data.details.description);
          if (res.data.details.work_file !== null && res.data.details.work_file !== "") {
            setHUrl(
              res.data.path +
              res.data.details.academy_code +
              "/homework/" +
              res.data.details.work_file
            );
          }
          academylist().then((res1) => {
            if (res1.status === true) {
              const matched = res1.data.details.find(
                (d) => d.id === res.data.details.academy_id
              );
              if (matched) {
                setAcaID({ value: matched.id, label: matched.name + " - " + matched.code });
              }
            }
          });
        }
      });
      listyear("");
    } else {
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            const matched = res.data.details.find(
              (d) => d.id == localStorage.getItem("AAcademy")
            );
            if (matched) {
              const sel = { value: matched.id, label: matched.name + " - " + matched.code };
              setAcaID(sel);
              listyear(sel);
              setAYear(localStorage.getItem("AYear"));
            }
          }
        });
      } else {
        listyear("");
      }
    }
  }, [location.pathname]);

  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        setAList(res.data.map((item) => ({ value: item.id, label: item.aca_year })));
      }
    });
    stusubjectlist(temp).then((res) => {
      if (res.status === true) {
        setSubList(res.data);
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listyear(e);
    } else {
      setAcaID("");
      listyear("");
    }
  }

  function handleClassChange(e) {
    const cls = e.target.value;
    setStuCls(cls);
    setStuSec([]);
    setStuList([]);
    setSelectedStu("");
  }

  function loadStudents(cls, sections, yr) {
    if (!cls) return;
    const temp = new FormData();
    temp.append("class", cls);
    if (yr) temp.append("year", yr);
    if (Array.isArray(sections) && sections.length > 0) {
      sections.forEach((sec) => temp.append("section[]", sec));
    } else if (sections && !Array.isArray(sections)) {
      temp.append("section", sections);
    }
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
      temp.append("academy", acaid.value);
    }
    studentfilter(temp).then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        setStuList(
          res.data.details.map((s) => ({
            value: s.id,
            label: s.username + " - " + s.student_name,
          }))
        );
      } else {
        setStuList([]);
      }
    });
  }

  function handleSubjectChange(selected) {
    setSubjects(selected || []);
    setSubjectDescs((prev) => {
      const next = {};
      (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
      return next;
    });
    setSubjectFiles((prev) => {
      const next = {};
      (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
      return next;
    });
    setSubjectFileUrls((prev) => {
      const next = {};
      (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
      return next;
    });
    setSubjectFileErrors((prev) => {
      const next = {};
      (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
      return next;
    });
  }

  function handleSubjectFile(subId, event) {
    setSubjectFileErrors((prev) => ({ ...prev, [subId]: "" }));
    setSubjectFiles((prev) => ({ ...prev, [subId]: "" }));
    if (event.target.files.length !== 0) {
      const file = event.target.files[0];
      if (!file.name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
        setSubjectFileErrors((prev) => ({ ...prev, [subId]: "Attachment should be jpg, jpeg, png or pdf format" }));
        return;
      }
      if (file.size / 1024 / 1024 > 5) {
        setSubjectFileErrors((prev) => ({ ...prev, [subId]: "Attachment size should be less than 5MB" }));
        return;
      }
      setSubjectFileUrls((prev) => ({ ...prev, [subId]: URL.createObjectURL(file) }));
      setSubjectFiles((prev) => ({ ...prev, [subId]: file }));
    }
  }

  function handleSubjectDesc(subId, val) {
    setSubjectDescs((prev) => ({ ...prev, [subId]: val }));
  }

  const [subhome, setSubHome] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submithome(e) {
    e.preventDefault();
    setSubHome(true);

    // validation
    if (localStorage.getItem("Role") === "1" && acaid === "") {
      toast.error("Please Select Academy");
      return;
    }
    if (!ayear) { toast.error("Please Select Academic Year"); return; }
    if (!stucls) { toast.error("Please Select Class"); return; }
    if (Array.isArray(stusec) ? stusec.length === 0 : !stusec) {
      toast.error("Please Select Section"); return;
    }
    if (subjects.length === 0) { toast.error("Please Select at least one Subject"); return; }
    if (!adate) { toast.error("Please Select Due Date"); return; }

    const hasEmptyDesc = subjects.some((s) => !subjectDescs[s.value]?.trim());
    if (hasEmptyDesc) { toast.error("Please enter description for all selected subjects"); return; }

    setLoading(true);

    const baseData = () => {
      const temp = new FormData();
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy", acaid.value);
      }
      temp.append("academic_year", ayear);
      temp.append("class_id", stucls);
      temp.append("due_date", adate);
      if (urllink !== "addhomework") temp.append("id", id);

      if (Array.isArray(stusec)) {
        stusec.forEach((sec) => temp.append("section[]", sec));
      } else {
        temp.append("section", stusec);
      }
      if (selectedStu) temp.append("student_id", selectedStu);
      return temp;
    };

    try {
      for (const sub of subjects) {
        const temp = baseData();
        temp.append("subject", sub.value);
        temp.append("description", subjectDescs[sub.value]);
        if (subjectFiles[sub.value]) temp.append("work_file", subjectFiles[sub.value]);
        const response = await createhomework(temp);
        if (!response || response.status !== true) {
          toast.error(response?.message || "Failed to save homework");
          setLoading(false);
          return;
        }
      }
      setLoading(false);
      toast.success("Homework Created Successfully");
      setSubHome(false);
      navigate("/homework/allhomework");
    } catch {
      setLoading(false);
      toast.error("Something went wrong");
    }
  }

  const subjectOptions = sublist.map((item) => ({
    value: item.id,
    label: item.subject_name,
  }));

  return (
    <div>
      <div className="page-header">
        {urllink === "addhomework" && (
          <h2 className="main-content-title tx-24 mg-b-5">Add HomeWork</h2>
        )}
        {urllink !== "addhomework" && (
          <h2 className="main-content-title tx-24 mg-b-5">HomeWork Detail</h2>
        )}
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>HomeWork</a></li>
          {urllink === "addhomework" ? (
            <li className="breadcrumb-item active" aria-current="page">Add HomeWork</li>
          ) : (
            <li className="breadcrumb-item active" aria-current="page">HomeWork Detail</li>
          )}
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">

                {/* VIEW MODE */}
                {urllink === "viewhomework" && (
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Select Academy</label>
                          <span>{acaid.label}</span>
                        </div>
                      </div>
                    )}
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Academic Year</label>
                        {alist.find(item => item.value === ayear) && (
                          <span>{alist.find(item => item.value === ayear).label}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Class</label>
                        {clist.find(item => item.value === stucls) && (
                          <span>{clist.find(item => item.value === stucls).label}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        {slist.find(item => item.value === stusec) && (
                          <span>{slist.find(item => item.value === stusec).label}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Subject</label>
                        {sublist.find(item => item.id === subject) && (
                          <span>{sublist.find(item => item.id === subject).subject_name}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Due Date</label>
                        <span>{moment(adate).format("DD-MM-YYYY")}</span>
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Homework Description</label>
                        <span>{hwork}</span>
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Attachment</label>
                        {hurl !== null && hurl !== "" &&
                          (hurl.split(".").pop() === "pdf" ? (
                            <a href={hurl} target="_blank" rel="noreferrer">
                              <img src={require("../../../assets/images/pdf.png")} alt="PDF File" width="100px" height="100px" />
                            </a>
                          ) : (
                            <a href={hurl} target="_blank" rel="noreferrer">
                              <img src={hurl} alt="Other File" width="100px" height="100px" />
                            </a>
                          ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* ADD / EDIT MODE */}
                {urllink !== "viewhomework" && (
                  <div className="row">

                    {/* Academy */}
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Select Academy <span className="text-danger">*</span></label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={aclist}
                            onChange={handleAcademy}
                            isSearchable
                            isClearable
                          />
                          {subhome && acaid === "" && (
                            <span className="text-danger">Please Select Academy</span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Academic Year */}
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Academic Year <span className="text-danger">*</span></label>
                        <select className="default-select form-control wide" onChange={(e) => setAYear(e.target.value)} value={ayear}>
                          <option value="" disabled>Select Academic Year</option>
                          {alist.map((item, i) => (
                            <option value={item.value} key={i}>{item.label}</option>
                          ))}
                        </select>
                        {subhome && !ayear && <span className="text-danger">Please Select Academic Year</span>}
                      </div>
                    </div>

                    {/* Class */}
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Class <span className="text-danger">*</span></label>
                        <select className="default-select form-control wide" onChange={handleClassChange} value={stucls}>
                          <option value="" disabled>Select Class</option>
                          {clist.map((item, i) => (
                            <option value={item.value} key={i}>{item.label}</option>
                          ))}
                        </select>
                        {subhome && !stucls && <span className="text-danger">Please Select Class</span>}
                      </div>
                    </div>

                    {/* Section */}
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Section <span className="text-danger">*</span></label>
                        {urllink === "addhomework" ? (
                          <Select
                            isMulti
                            options={slist}
                            value={slist.filter((s) => Array.isArray(stusec) && stusec.includes(s.value))}
                            onChange={(sel) => {
                              const vals = sel ? sel.map((o) => o.value) : [];
                              setStuSec(vals);
                              setStuList([]);
                              setSelectedStu("");
                              loadStudents(stucls, vals, ayear);
                            }}
                            placeholder="Select Sections"
                            className="default-select"
                          />
                        ) : (
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => setStuSec(e.target.value)}
                            value={stusec}
                          >
                            <option value="" disabled>Select Section</option>
                            {slist.map((item, i) => (
                              <option key={i} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                        )}
                        {subhome && (Array.isArray(stusec) ? stusec.length === 0 : !stusec) && (
                          <span className="text-danger">Please Select Section</span>
                        )}
                      </div>
                    </div>

                    {/* Student — optional */}
                    {urllink === "addhomework" && (
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Student <span className="text-muted tx-12">(Optional)</span></label>
                          <Select
                            className="default-select"
                            placeholder="Select Student"
                            value={stulist.find((s) => s.value === selectedStu) || null}
                            options={stulist}
                            onChange={(e) => setSelectedStu(e ? e.value : "")}
                            isSearchable
                            isClearable
                          />
                        </div>
                      </div>
                    )}

                    {/* Subject multi-select */}
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Subject <span className="text-danger">*</span></label>
                        <Select
                          isMulti
                          className="default-select"
                          placeholder="Select Subject(s)"
                          value={subjects}
                          options={subjectOptions}
                          onChange={handleSubjectChange}
                          isSearchable
                        />
                        {subhome && subjects.length === 0 && (
                          <span className="text-danger">Please Select Subject</span>
                        )}
                      </div>
                    </div>

                    {/* Due Date */}
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Due Date <span className="text-danger">*</span></label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setADate(e.target.value)}
                          value={adate}
                        />
                        {subhome && !adate && <span className="text-danger">Please Select Due Date</span>}
                      </div>
                    </div>

                    {/* Per-subject descriptions */}
                    {subjects.length > 0 && (
                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label fw-bold">Homework Description <span className="text-danger">*</span></label>
                          <div className="row">
                            {subjects.map((sub) => (
                              <div className="col-xl-6 col-sm-12 mb-3" key={sub.value}>
                                <label className="form-label fw-semibold">{sub.label}</label>
                                <textarea
                                  className="form-control mb-2"
                                  rows="3"
                                  placeholder={`Description for ${sub.label}`}
                                  value={subjectDescs[sub.value] || ""}
                                  onChange={(e) => handleSubjectDesc(sub.value, e.target.value)}
                                />
                                {subhome && !subjectDescs[sub.value]?.trim() && (
                                  <span className="text-danger d-block mb-1">Please enter description for {sub.label}</span>
                                )}
                                <input
                                  type="file"
                                  className="form-control"
                                  accept=".pdf,.jpg,.png,.jpeg"
                                  onChange={(e) => handleSubjectFile(sub.value, e)}
                                />
                                <small className="text-danger">File Format: .pdf, .jpg, .png, .jpeg (max 5MB)</small>
                                {subjectFileErrors[sub.value] && (
                                  <span className="text-danger d-block">{subjectFileErrors[sub.value]}</span>
                                )}
                                {subjectFileUrls[sub.value] && (
                                  <div className="mt-1">
                                    {subjectFileUrls[sub.value].endsWith(".pdf") || subjectFiles[sub.value]?.name?.endsWith(".pdf") ? (
                                      <a href={subjectFileUrls[sub.value]} target="_blank" rel="noreferrer">
                                        <img src={require("../../../assets/images/pdf.png")} alt="PDF" width="60px" height="60px" />
                                      </a>
                                    ) : (
                                      <a href={subjectFileUrls[sub.value]} target="_blank" rel="noreferrer">
                                        <img src={subjectFileUrls[sub.value]} alt="Attachment" width="60px" height="60px" />
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                )}

              </div>
              <div className="res-right mt-2 me-4 mb-4">
                {urllink !== "viewhomework" && (
                  <button className="btn btn-success me-2" onClick={submithome}>
                    Submit
                  </button>
                )}
                {urllink !== "addhomework" && (
                  <button className="btn btn-secondary" onClick={() => navigate("/homework/allhomework")}>
                    Back
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
